import { h } from 'preact';
import { forwardRef } from 'preact/compat';

const Input = forwardRef(({ className = '', error, id, name, ...props }, ref) => {
  // FormLabel renders htmlFor={name}, so the id has to match it.
  const fieldId = id || name;

  return (
    <input
      ref={ref}
      id={fieldId}
      name={name}
      aria-invalid={error ? 'true' : undefined}
      aria-describedby={error && fieldId ? `${fieldId}-error` : undefined}
      className={`flex h-10 w-full mb-0 border bg-white px-3 py-2 text-sm ring-offset-white placeholder:text-gray-400 focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50 ${
        error
          ? 'border-coit-error focus-visible:ring-coit-error'
          : 'border-gray-300 focus-visible:ring-black'
      } ${className}`}
      {...props}
    />
  );
});

export default Input;
